$(function(){
    var $menu = $('.header__bottom');
    var $burger = $(".header__burger");
    var $body = $('body');
    var $fade = $('.body__wrapper');
    $menu.on('click', function(e){
        e.stopPropagation();
    });
    $burger
        .on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if($burger.hasClass("header__burger_open")){
                $burger.removeClass("header__burger_open");
                $menu.removeClass("header__bottom_open");
                $body.off(".menu-close");
                $body.removeClass('body_fade');
            }else{
                $burger.addClass("header__burger_open");
                $menu.addClass("header__bottom_open");
                $body.addClass('body_fade');
                setTimeout(function() {
                    $body.off(".menu-close").on('click.menu-close', function(e){
                        $burger.removeClass("header__burger_open");
                        $menu.removeClass('header__bottom_open');
                        $body.removeClass('body_fade');
                        $body.off(".menu-close");
                    });
                },10);
            }
        });
});
